import React from 'react';

import EntityDropDownFilterContainerComponent from 'components/entityViewer/entitiesDropDownFilter/EntityDropDownFilterContainer';

import { OosLogFilterConfigArray } from './OosLogFilterConfig';

/** Stable default so `initialValues` is not a fresh `{}` every render (avoids spurious sync effects). */
const EMPTY_INITIAL_FILTER_VALUES = Object.freeze({});

/**
 * @param {Object} props
 * @param {Object} [props.initialValues={}]
 * @param {(filterValues: Object) => void} [props.onChange]
 */
export function OosLogFilters({ initialValues = EMPTY_INITIAL_FILTER_VALUES, onChange }) {
    const handleFilterChange = (filterValues) => {
        onChange?.(filterValues);
    };

    return (
        <EntityDropDownFilterContainerComponent
            title="Out of Stock Log Filters"
            filterConfigs={OosLogFilterConfigArray}
            initialValues={initialValues}
            onChange={handleFilterChange}
            autoApply
        />
    );
}
